/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import SubUsers from '../../../../../components/Forms/users';

const mod = "cadd";

export default function CADDUsers() {
  return <SubUsers mod={mod} />
};
